import { Component, OnInit } from '@angular/core';
import { SettingsService } from './services/settings.service';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.css']
})

export class AppComponent implements OnInit {

  constructor(public settingsService: SettingsService, public authService: AuthService) { }

  ngOnInit() {
  }

}
